import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { editProfilePost } from "../repositories/userRepo";

const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const editProfileData = createAsyncThunk(
  "editProfile",
  async (data, thunkAPI) => {
    const response = await editProfilePost(data);
    return response;
  }
);
export const editProfileSlice = createSlice({
  name: "editProfile",
  initialState,
  extraReducers: {
    [editProfileData.pending]: (state) => {
      state.loading = true;
    },
    [editProfileData.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [editProfileData.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default editProfileSlice.reducer;
